import React, { useEffect } from 'react'
import RoleActivityTimelineItem from './RoleActivityTimelineItem'
import ATLoaderContainer from '../../../common/loaderContainer/ATLoaderContainer'
import ATModuleMessage from '../../../common/message/ATModuleMessage'
import { useLazyGetRoleActivityQuery } from '../../../../api/app/UserManagementApiService'
import { RoleActivityItem } from '../../../../interface/response/RoleActivityResponse'

interface RoleActivityProps {
  roleCode?: string
  onApplicationName: (name: string) => void
}

const RoleActivity: React.FC<RoleActivityProps> = ({
  roleCode,
  onApplicationName,
}) => {
  const [getRoleActivityData, roleActivityData] = useLazyGetRoleActivityQuery()

  useEffect(() => {
    if (roleCode) {
      getRoleActivityData(roleCode)
    }
  }, [roleCode, getRoleActivityData])

  useEffect(() => {
    if (roleActivityData?.isSuccess && onApplicationName) {
      onApplicationName(roleActivityData?.data?.applicationName ?? '')
    }
  }, [
    roleActivityData?.isSuccess,
    roleActivityData?.data?.applicationName,
    onApplicationName,
  ])

  if (!roleActivityData?.data || roleActivityData?.data?.events?.length === 0) {
    return (
      <ATLoaderContainer>
        <ATModuleMessage />
      </ATLoaderContainer>
    )
  }

  return (
    <div className="overflow-auto">
      {roleActivityData?.data?.events?.map((item: RoleActivityItem) => (
        <RoleActivityTimelineItem key={item?.eventGroupKey} item={item} />
      ))}
    </div>
  )
}

export default RoleActivity
